
import { useState } from 'react'

import { CataloguesWrapper, StyledCatalogueBox, StyledLink } from "./CataloguesStyles";

const Catalogues = ({ bgImage, catalogueImages }) => {

    const catalogues = [
      {
        id: 0,
        image: "",
        heading: "Weather",
        text: "With a hairstyle for every weather, you'll definitely find a right fit for you and the weather in this catalogue.",
        inFocus: false,
      },
      {
        id: 1,
        image: "",
        heading: "Texture",
        text: "This catalogue provides a wide range of hairstyles for you to pick from based on yur hair texture.",
        inFocus: false,
      },
      {
        id: 2,
        image: "",
        heading: "Event",
        text: "Weddings, Galas, Birthdays, name it. You'll certainly find the perfect style for any event.",
        inFocus: false,
      },
      {
        id: 3,
        image: "",
        heading: "Explore",
        text: "Not hooked on any Catalog in particular? Check out more amazing styles.",
        inFocus: false,
      },
    ];
    const [finalCatalogues, setCatalogues] = useState(
        catalogues.map( catalogue => {
            return({...catalogue, image: catalogueImages[catalogue.id]})
        }))
    const setFocus = (id) => {
        setCatalogues((initialCatalogues) => {
            return initialCatalogues.map((catalogue) => {
              return id === catalogue.id
                ? { ...catalogue, inFocus: true }
                : { ...catalogue, inFocus: false };
            });
        })
    }
        const removeFocus = (id) => {
          setCatalogues((initialCatalogues) => {
            return initialCatalogues.map((catalogue) => {
              return id === catalogue.id
                ? { ...catalogue, inFocus: false } :  catalogue
            });
          }); 
        };
    return ( 
      <CataloguesWrapper bg={bgImage}>
        <h1>Catalogues</h1>
        <p>
          <span>
            Choose a style from our catalogues. You pick it, We style it.
          </span>
        </p>
        <div>
            {finalCatalogues.map(catalogue => {
                return (
                  <StyledLink
                    onClick={(e) => {
                      e.preventDefault();
                      setFocus(catalogue.id);
                    }}
                    onFocus={(e) => {
                      e.preventDefault();
                      setFocus(catalogue.id);
                    }}
                    onMouseOver={(e) => {
                      e.preventDefault();
                      setFocus(catalogue.id);
                    }}
                    onBlur={(e) => {
                      removeFocus(catalogue.id);
                    }} 
                    onMouseLeave={(e) => {
                      removeFocus(catalogue.id);
                    }}
                    key={catalogue.id}
                    to="#"
                  >
                    <StyledCatalogueBox
                      to="#"
                      inFocus={catalogue.inFocus}
                      key={catalogue.id}
                      bgImage={catalogue.image}
                    >
                      <h3>{catalogue.heading}</h3>
                      <div>
                        <p>{catalogue.text}</p>
                        <button>
                          {catalogue.heading === "Explore"
                            ? "Explore"
                            : "View Catalogue"}
                        </button>
                      </div>
                    </StyledCatalogueBox>
                  </StyledLink>
                );
            })}
        </div>
      </CataloguesWrapper>   
    );
}

export default Catalogues
